module.exports = __webpack_public_path__ + "static/media/CA.b0e7b1d2.png";